export const RECOMMEND_CODES = [
  'KREW',
  'KOMMUNITY',
  'TEEN_CARD',
  'LOCAL_CARD',
  'CERT_CARD',
  'STUDENT_ID',
  'EMPLOYEE_ID',
  'KOREADULLE_TRAIL',
  'KARECHAT',
  'MYCAR'
] as const;

export type RecommendCode = (typeof RECOMMEND_CODES)[number];

export const RECOMMEND_CODES_USING_PAPAS = ['TEEN_CARD', 'LOCAL_CARD', 'CERT_CARD'] as const;

export type RecommendCodeUsingPapas = (typeof RECOMMEND_CODES_USING_PAPAS)[number];
